"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CancelledError", {
  enumerable: true,
  get: function get() {
    return _reactQuery.CancelledError;
  }
});
Object.defineProperty(exports, "Hydrate", {
  enumerable: true,
  get: function get() {
    return _reactQuery.Hydrate;
  }
});
Object.defineProperty(exports, "InfiniteQueryObserver", {
  enumerable: true,
  get: function get() {
    return _reactQuery.InfiniteQueryObserver;
  }
});
Object.defineProperty(exports, "IsRestoringProvider", {
  enumerable: true,
  get: function get() {
    return _reactQuery.IsRestoringProvider;
  }
});
Object.defineProperty(exports, "MutationCache", {
  enumerable: true,
  get: function get() {
    return _reactQuery.MutationCache;
  }
});
Object.defineProperty(exports, "MutationObserver", {
  enumerable: true,
  get: function get() {
    return _reactQuery.MutationObserver;
  }
});
Object.defineProperty(exports, "QueriesObserver", {
  enumerable: true,
  get: function get() {
    return _reactQuery.QueriesObserver;
  }
});
Object.defineProperty(exports, "QueryCache", {
  enumerable: true,
  get: function get() {
    return _reactQuery.QueryCache;
  }
});
Object.defineProperty(exports, "QueryClient", {
  enumerable: true,
  get: function get() {
    return _reactQuery.QueryClient;
  }
});
Object.defineProperty(exports, "QueryClientProvider", {
  enumerable: true,
  get: function get() {
    return _reactQuery.QueryClientProvider;
  }
});
Object.defineProperty(exports, "QueryErrorResetBoundary", {
  enumerable: true,
  get: function get() {
    return _reactQuery.QueryErrorResetBoundary;
  }
});
Object.defineProperty(exports, "QueryObserver", {
  enumerable: true,
  get: function get() {
    return _reactQuery.QueryObserver;
  }
});
Object.defineProperty(exports, "ReactQueryDevtools", {
  enumerable: true,
  get: function get() {
    return _reactQueryDevtools.ReactQueryDevtools;
  }
});
Object.defineProperty(exports, "defaultContext", {
  enumerable: true,
  get: function get() {
    return _reactQuery.defaultContext;
  }
});
Object.defineProperty(exports, "dehydrate", {
  enumerable: true,
  get: function get() {
    return _reactQuery.dehydrate;
  }
});
Object.defineProperty(exports, "focusManager", {
  enumerable: true,
  get: function get() {
    return _reactQuery.focusManager;
  }
});
Object.defineProperty(exports, "hashQueryKey", {
  enumerable: true,
  get: function get() {
    return _reactQuery.hashQueryKey;
  }
});
Object.defineProperty(exports, "hydrate", {
  enumerable: true,
  get: function get() {
    return _reactQuery.hydrate;
  }
});
Object.defineProperty(exports, "isCancelledError", {
  enumerable: true,
  get: function get() {
    return _reactQuery.isCancelledError;
  }
});
Object.defineProperty(exports, "isError", {
  enumerable: true,
  get: function get() {
    return _reactQuery.isError;
  }
});
Object.defineProperty(exports, "isServer", {
  enumerable: true,
  get: function get() {
    return _reactQuery.isServer;
  }
});
Object.defineProperty(exports, "notifyManager", {
  enumerable: true,
  get: function get() {
    return _reactQuery.notifyManager;
  }
});
Object.defineProperty(exports, "onlineManager", {
  enumerable: true,
  get: function get() {
    return _reactQuery.onlineManager;
  }
});
Object.defineProperty(exports, "parseFilterArgs", {
  enumerable: true,
  get: function get() {
    return _reactQuery.parseFilterArgs;
  }
});
Object.defineProperty(exports, "parseMutationArgs", {
  enumerable: true,
  get: function get() {
    return _reactQuery.parseMutationArgs;
  }
});
Object.defineProperty(exports, "parseMutationFilterArgs", {
  enumerable: true,
  get: function get() {
    return _reactQuery.parseMutationFilterArgs;
  }
});
Object.defineProperty(exports, "parseQueryArgs", {
  enumerable: true,
  get: function get() {
    return _reactQuery.parseQueryArgs;
  }
});
Object.defineProperty(exports, "useHydrate", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useHydrate;
  }
});
Object.defineProperty(exports, "useInfiniteQuery", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useInfiniteQuery;
  }
});
Object.defineProperty(exports, "useIsFetching", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useIsFetching;
  }
});
Object.defineProperty(exports, "useIsMutating", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useIsMutating;
  }
});
Object.defineProperty(exports, "useIsRestoring", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useIsRestoring;
  }
});
Object.defineProperty(exports, "useMutation", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useMutation;
  }
});
Object.defineProperty(exports, "useQueries", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useQueries;
  }
});
Object.defineProperty(exports, "useQuery", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useQuery;
  }
});
Object.defineProperty(exports, "useQueryClient", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useQueryClient;
  }
});
Object.defineProperty(exports, "useQueryErrorResetBoundary", {
  enumerable: true,
  get: function get() {
    return _reactQuery.useQueryErrorResetBoundary;
  }
});
var _reactQuery = require("@tanstack/react-query");
var _reactQueryDevtools = require("@tanstack/react-query-devtools");